import React  from "react";
import {DOCS_SAMPLE_PREPARATION_ROUTE} from "../../Routes";
import {motion} from "framer-motion";
import {Link} from "react-router-dom";

type SamplePreparationLinkProps = {
    species: string;
}

export const SamplePreparationLink: React.FC<SamplePreparationLinkProps> = ({species, ...props}) => {
    if(!species) return null;
    const url = `${DOCS_SAMPLE_PREPARATION_ROUTE}?query=${encodeURIComponent(species)}`;

    return (
        <motion.li
            initial={{
                opacity: 0,
            }}
            animate={{
                opacity: 1,
            }}
            {...props}
        >
            <Link to={url} target="_blank">{species} - Sample preparation</Link>
        </motion.li>
    )
}